{
  "Accessibility Menu": "Μενού προσβασιμότητας",
  "Reset settings": "Επαναφορά ρυθμίσεων",
  "Close": "Κλείσιμο",
  "Content Adjustments": "Προσαρμογές περιεχομένου",
  "Adjust Font Size": "Προσαρμογή μεγέθους γραμματοσειράς",
  "Highlight Title": "Επισήμανση τίτλου",
  "Highlight Links": "Επισήμανση συνδέσμων",
  "Readable Font": "Ευανάγνωστη γραμματοσειρά",
  "Color Adjustments": "Προσαρμογές χρωμάτων",
  "Dark Contrast": "Αντίθεση σε σκούρο",
  "Light Contrast": "Αντίθεση σε φωτεινό",
  "High Contrast": "Υψηλή αντίθεση",
  "High Saturation": "Υψηλός κορεσμός",
  "Low Saturation": "Χαμηλός κορεσμός",
  "Monochrome": "Μονόχρωμο",
  "Contrast": "Αντίθεση",
  "Invert Colors": "Αντιστροφή χρωμάτων",
  "Tools": "Εργαλεία",
  "Reading Guide": "Οδηγός ανάγνωσης",
  "Stop Animations": "Αφαίρεση κίνησης",
  "Big Cursor": "Μεγάλος κέρσορας",
  "Increase Font Size": "Αύξηση μεγέθους γραμματοσειράς",
  "Decrease Font Size": "Μείωση μεγέθους γραμματοσειράς",
  "Letter Spacing": "Διάκενο γραμμάτων",
  "Line Height": "Ύψος γραμμής",
  "Font Weight": "Βάρος γραμματοσειράς",
  "Dyslexia Font": "Γραμματοσειρά για δυσλεξία",
  "Language": "Γλώσσα",
  "Open Accessibility Menu": "Ανοίξτε το μενού προσβασιμότητας",
  "Widget Settings": "Ρυθμίσεις γραφικού στοιχείου",
  "Widget Position": "Θέση γραφικού στοιχείου",
  "Top Left": "Πάνω αριστερά",
  "Top Center": "Πάνω κέντρο",
  "Top Right": "Πάνω δεξιά",
  "Center Left": "Κέντρο αριστερά",
  "Center Right": "Κέντρο δεξιά",
  "Bottom Left": "Κάτω αριστερά",
  "Bottom Center": "Κάτω κέντρο",
  "Bottom Right": "Κάτω δεξιά",
  "Screen Reader": "Αναγνώστης οθόνης",
  "Voice Navigation": "Φωνητική πλοήγηση",
  "Custom Color": "Προσαρμοσμένο χρώμα",
  "Change the site's colors": "Αλλάξτε τα χρώματα του ιστότοπου",
  "Backgrounds": "Φόντα",
  "Headings": "Επικεφαλίδες",
  "Contents": "Περιεχόμενα",
  "Reset colors": "Επαναφορά χρωμάτων",
  "Image Desaturation": "Αποκορεσμός εικόνας",
  "Search languages": "Αναζήτηση γλωσσών",
  "No languages found": "Δεν βρέθηκαν γλώσσες",
  "Accessibility Profiles": "Προφίλ προσβασιμότητας",
  "Motor Impaired": "Κινητική αναπηρία",
  "Big cursor, voice navigation, and no animations.": "Μεγάλος δρομέας, φωνητική πλοήγηση και χωρίς κινούμενα.",
  "Blind": "Τυφλός",
  "Screen reader helpers with higher contrast.": "Βοηθήματα αναγνώστη οθόνης με υψηλότερη αντίθεση.",
  "Color Blind": "Αχρωματοψία",
  "High contrast palette with desaturated media.": "Παλέτα υψηλής αντίθεσης με αποκορεσμένα μέσα.",
  "Dyslexia": "Δυσλεξία",
  "Friendly font, extra spacing, stronger weight.": "Φιλική γραμματοσειρά, επιπλέον διάστιχο και πιο έντονο πάχος.",
  "Low vision": "Χαμηλή όραση",
  "Dark contrast and 130% magnification.": "Σκούρα αντίθεση και μεγέθυνση 130%.",
  "Cognitive & Learning": "Γνωστικό & μάθηση",
  "Highlights key sections and enables voice help.": "Τονίζει βασικές ενότητες και ενεργοποιεί φωνητική βοήθεια.",
  "Seizure & Epileptic": "Κρίσεις & επιληψία",
  "Stops animations and desaturates imagery.": "Σταματά κινούμενα και αποχρωματίζει εικόνες.",
  "ADHD": "ΔΕΠΥ",
  "Reading guide, highlighted links, calmer palette.": "Οδηγός ανάγνωσης, τονισμένοι σύνδεσμοι και πιο ήρεμη παλέτα.",
  "Widget Size": "Widget Size",
  "Default": "Default",
  "Medium": "Medium",
  "Small": "Small",
  "Color Blindness": "Color Blindness",
  "Protanopia": "Protanopia",
  "Deuteranopia": "Deuteranopia",
  "Tritanopia": "Tritanopia",
  "Achromatopsia": "Achromatopsia",
  "Simulates and assists users with color vision deficiencies.": "Simulates and assists users with color vision deficiencies."
}
